var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49984 1.2H15.6665C15.7382 1.2 15.7998 1.2616 15.7998 1.33333V6.33333C15.7998 6.40507 15.7382 6.46667 15.6665 6.46667H1.49984C1.4281 6.46667 1.3665 6.40507 1.3665 6.33333V1.33333C1.3665 1.2616 1.4281 1.2 1.49984 1.2ZM1.49984 9.53333H15.6665C15.7382 9.53333 15.7998 9.59493 15.7998 9.66667V14.6667C15.7998 14.7384 15.7382 14.8 15.6665 14.8H1.49984C1.4281 14.8 1.3665 14.7384 1.3665 14.6667V9.66667C1.3665 9.59493 1.4281 9.53333 1.49984 9.53333Z",
    stroke: "#999999",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningPlans);
export default __webpack_public_path__ + "static/media/learningPlans.97ce18229cb6fab57be05b06be3b592d.svg";
export { ForwardRef as ReactComponent };